import type { ReactNode } from 'react';
import React, { useCallback, useContext } from 'react';

import type { FeatureFlagContextType } from './feature-flag-context';
import { FeatureFlagContext } from './feature-flag-context';

interface ProviderProps {
  children: ReactNode;
}

export const FeatureFlagProvider: React.FC<ProviderProps> = ({ children }) => {
  const isFeatureEnabled = useCallback((_: string): boolean => false, []);
  const refreshFlags = useCallback(async (): Promise<void> => {}, []);

  return (
    <FeatureFlagContext.Provider
      value={{ isFeatureEnabled, refreshFlags, loading: false }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};

/**
 * Hook to access feature flag utilities.
 */
export function useFeatureFlags(): FeatureFlagContextType {
  return useContext(FeatureFlagContext);
}
